<template>
	<v-layout>
		<v-flex sm12 md6>
			<p class="add-event-step-header">Additional information</p>
			<p class="add-event-step-secondary-header mb-0">Host Notes</p>
			<p class="add-event-step-sub-header mb-0">Any special instructions that will help your guests, including “what to bring” (e.g. Yoga Mat, Journal, etc.), and, if necessary, how to access the event location (e.g. ring doorbell).</p>
			<v-textarea color="link" class="ml-2 mb-2 pt-0 add-event-text-box" v-model="notes" placeholder="Enter event notes"></v-textarea>
			<p class="add-event-step-secondary-header mb-0">House Rules</p>
			<p class="add-event-step-sub-header mb-0">This is pre-populated from the Location information. Please review and add any additional rules that will apply to this specific event (e.g. no food containing peanuts).</p>
			<v-textarea color="link" class="ml-2 pt-0 add-event-text-box" v-model="rules" placeholder="Enter your location rules"></v-textarea>
		</v-flex>
		<v-flex md4 offset-md1 hidden-sm-and-down class="pt-3">
			<v-card class="add-event-tip-box">
				<v-card-text class="p-relative pt-5">
					<div class="info-trapezoid p-absolute">
						<div class="info-content">
							<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
						</div>
					</div>
					<p class="add-event-tip-title">Special Instructions</p>
					<p class="add-event-tip-content">Make sure your guests have all the information they’ll need. Let them know if they’ll need to call you or ring a doorbell upon arrival, or if there is anything they should bring with them.</p>
					<p class="add-event-tip-content">Common things guests should be reminded to bring include what they’ll need to do their work (e.g. Laptop, headphones, etc.) and whatever you expect would be helpful for any extracurriculars you have planned (e.g. a Yoga Mat for a morning meditation).</p>
					<p class="add-event-tip-title">Rules</p>
					<p class="add-event-tip-content">If you have any rules that need to be followed list them in the House Rules. Things like "No Smoking" or "Don't use the upstairs bathroom" will help guests to know their boundaries in your space, and make the experience better for all!</p>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-dialog scrollable v-model="infoDialog">
			<v-card style="width: 100%">
				<v-card-title class="mb-0 pb-2 pt-3">
					<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
				</v-card-title>
				<v-card-text style="max-height:50vh;">
					<p class="add-event-tip-title">Special Instructions</p>
					<p class="add-event-tip-content">Make sure your guests have all the information they’ll need. Let them know if they’ll need to call you or ring a doorbell upon arrival, or if there is anything they should bring with them.</p>
					<p class="add-event-tip-content">Common things guests should be reminded to bring include what they’ll need to do their work (e.g. Laptop, headphones, etc.) and whatever you expect would be helpful for any extracurriculars you have planned (e.g. a Yoga Mat for a morning meditation).</p>
					<p class="add-event-tip-title">Rules</p>
					<p class="add-event-tip-content">If you have any rules that need to be followed list them in the House Rules. Things like "No Smoking" or "Don't use the upstairs bathroom" will help guests to know their boundaries in your space, and make the experience better for all!</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer>
					</v-spacer>
					<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- <div class="mb-3 add-event-step-info-link" @click="infoDialog=true"><v-icon class="add-event-step-info-icon">fa-info-circle</v-icon> Tips</div> -->
	</v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	data() {
		return {
			types: [
				{
					title: 'Wrkprty',
					value: 'wrkprty',
					description:
						'This is the wrkprty. A Wrkprty is a great way to get together with like minded people to work.'
				},
				{
					title: 'Wrkshp',
					value: 'wrkshp',
					description: 'This is a work shop'
				},
				{
					title: 'Mstrmnd',
					value: 'mstrmnd',
					description: 'This is smart work party'
				},
				{
					title: 'Prsnts',
					value: 'prsnts',
					description: 'This is the presentation'
				}
			]
		}
	},
	beforeRouteLeave(to, from, next) {
		this.setAddEventValidStep(from.path)
		this.removeAddEventInvalidStep(from.path)
		next()
	},
	methods: {
		...mapActions(['setAddEventProp', 'setAddEventValidStep', 'removeAddEventInvalidStep'])
	},
	computed: {
		...mapGetters(['getAddEventProp']),
		notes: {
			get() {
				return this.getAddEventProp('notes')
			},
			set(val) {
				this.setAddEventProp({ prop: 'notes', value: val })
			}
		},
		parking: {
			get() {
				return this.getAddEventProp('parkingInfo')
			},
			set(val) {
				this.setAddEventProp({ prop: 'parkingInfo', value: val })
			}
		},
		rules: {
			get() {
				return this.getAddEventProp('rules')
			},
			set(val) {
				this.setAddEventProp({ prop: 'rules', value: val })
			}
		},
		infoDialog: {
			get() {
				return this.getAddEventProp('infoDialog')
			},
			set(val) {
				this.setAddEventProp({ prop: 'infoDialog', value: val })
			}
		},
		freeParking: {
			get() {
				return this.getAddEventProp('freeParking')
			},
			set(val) {
				this.setAddEventProp({ prop: 'freeParking', value: val })
			}
		},
		streetParking: {
			get() {
				return this.getAddEventProp('streetParking')
			},
			set(val) {
				this.setAddEventProp({ prop: 'streetParking', value: val })
			}
		},
		paidLot: {
			get() {
				return this.getAddEventProp('paidLot')
			},
			set(val) {
				this.setAddEventProp({ prop: 'paidLot', value: val })
			}
		},
		freeParkingText: {
			get() {
				return this.getAddEventProp('freeParkingText')
			},
			set(val) {
				this.setAddEventProp({ prop: 'freeParkingText', value: val })
			}
		},
		streetParkingAddress: {
			get() {
				return this.getAddEventProp('streetParkingAddress')
			},
			set(val) {
				this.setAddEventProp({ prop: 'streetParkingAddress', value: val })
			}
		},
		paidLotAddress: {
			get() {
				return this.getAddEventProp('paidLotAddress')
			},
			set(val) {
				this.setAddEventProp({ prop: 'paidLotAddress', value: val })
			}
		},
		paidLotPrice: {
			get() {
				console.log(this.getAddEventProp('paidLotPrice'))
				return parseInt(this.getAddEventProp('paidLotPrice'))
			},
			set(val) {
				this.setAddEventProp({ prop: 'paidLotPrice', value: val })
			}
		}
	}
}
</script>

<style>
</style>
